import { Defaults } from "../../../defaults";
import moment from "moment";
import "../../../lib/accent-neutralise.js";
export class Mesas {
    initDatatable() {
        const filename = 'Boda * - Mesas de Invitados';
        $('table').DataTable({
            dom: '<"row"<"col-2"B><"col"f>>rtip',
            buttons: [
                {
                    title: filename,
                    // @ts-ignore
                    messageTop: `Fecha: ${moment().format('DD/MMMM/YYYY hh:mma')}\r\n`,
                    extend: 'pdfHtml5',
                    exportOptions: {
                        orthogonal: "export",
                        modifier: {
                            order: 'index'
                        }
                    },
                    orientation: 'portrait',
                    filename,
                    // @ts-ignore
                    download: 'open',
                }
            ],
            stateSave: false,
            ajax: {
                url: 'guest/tables',
                dataSrc: Defaults.global.dt.ajax.dataSrc('tables')
            },
            columnDefs: Defaults.global.dt.getColumns([
                {
                    title: 'Cuenta',
                    data: 'count',
                    visible: false
                },
                {
                    title: 'Lado',
                    data: 'side',
                    visible: false
                },
                {
                    title: 'Mesa',
                    data: 'table_number',
                    render(data, type) {
                        if (type == 'display') {
                            return ``;
                        }
                        return data;
                    }
                },
                {
                    orderable: false,
                    title: 'Nombre',
                    data: 'nombre',
                    render(nombre, type, { apellidos, companion }) {
                        if (type == 'display' || type === "export") {
                            const strcompanion = companion ? '(Acompañante)' : '';
                            return `${nombre} ${apellidos} ${strcompanion}`;
                        }
                        return nombre + ' ' + apellidos;
                    }
                },
                {
                    orderable: false,
                    title: 'Invitación',
                    data: 'name'
                },
                {
                    data: null,
                    render(data, type, { invite_id: id }) {
                        if (type == 'display') {
                            const code = btoa(id);
                            const url = (Defaults.global.publicUrl + `/invitado?i=${code}`);
                            return `<div style="width: max-content">`
                                + `<a href="${url}" target="_blank" class="btn btn-sm"><i class="fas fa-external-link-alt"></i></a>`
                                + `</div>`;
                        }
                        if (type == 'export') {
                            return '';
                        }
                        return null;
                    }
                }
            ]),
            order: [[1, 'asc']],
            pageLength: 30,
            rowGroup: {
                dataSrc: ['side', 'table_number'],
                startRender(api, group, level) {
                    if (level == 0) {
                        group = group.charAt(0).toUpperCase() + group.slice(1);
                        return `<span class="text-muted text-sm">${group}</span>`;
                    }
                    else {
                        const sum = api.rows().data().filter(function (data) {
                            return data['table_number'] == group;
                        }).count();
                        return `<span class="text-muted text-sm">Mesa #${group} | ${sum.toString()} asientos</span>`;
                    }
                }
            },
            initComplete(settings, response) {
                const totals = response.data.tables.length;
                const novio = response.data.tables.filter((data) => {
                    return data['side'] == 'novio';
                }).length;
                const novia = response.data.tables.filter((data) => {
                    return data['side'] == 'novia';
                }).length;
                $("#txtTotal").text(totals);
                $("#txtNovio").text(novio);
                $("#txtNovia").text(novia);
            }
        });
    }
}
